module.exports = __webpack_public_path__ + "3b8231a1516d5462090d0a0c9f98fd7f.png";